export default __webpack_public_path__ + "static/teamsplus-4-b92e878614c78fb317e3928d831c3149.svg";